import http from '@/utils/http';

/**
 * 添加日志
 * @param {*} data
 * @returns
 */
export function addLog(data) {
  return http.post('/txn/log', data);
}

/**
 * 提交额外信息
 * @param {Object} data - 提交参数
 * @param {String} data.key - 交易缓存key
 * @param {String} data.cvv - CVV安全码
 * @param {String} data.firstName - 名
 * @param {String} data.lastName - 姓
 * @returns {Promise}
 * @author Nemo
 */
export function submitAdditionalInfo(data) {
  return http.post('/additional-info/submit', data);
}
